import {
  ConsumerComponentType,
  OperationalPurpose,
  TaxReliefProcesses
} from "../../../types/api.types";
import type { FormInputData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { CONSUMER_TAB_VALUES } from "../ConsumerWizard.constants";
import type { ConsumerFormData } from "./ConsumerForm.types";

const TAX_RELIEF_HELP_TEXT =
  "Prozesse gemäß § 9a StromStG sind:\n\n" +
  "- Elektrolyse,\n" +
  "- die Herstellung von Glas und Glaswaren, keramischen Erzeugnissen, keramischen Wand- und Bodenfliesen und -platten, Ziegeln und sonstiger Baukeramik, Zement, Kalk und gebranntem Gips, Erzeugnissen aus Beton, Zement und Gips, keramisch gebundenen Schleifkörpern, mineralischen Isoliermaterialien und Erzeugnissen daraus, Katalysatorenträgern aus mineralischen Stoffen, Waren aus Asphalt und bituminösen Erzeugnissen, Waren aus Graphit oder anderen Kohlenstoffen, Erzeugnissen aus Porenbetonerzeugnissen zum Trocknen, Kalzinieren, Brennen, Schmelzen, Erwärmen, Warmhalten, Entspannen, Tempern oder Sintern der vorgenannten Erzeugnisse oder der zu ihrer Herstellung verwendeten Vorprodukte,\n" +
  "- die Metallerzeugung und -bearbeitung, sowie im Rahmen der Herstellung von Metallerzeugnissen die Herstellung von Schmiede-, Press-, Zieh- und Stanzteilen, gewalzten Ringen und pulvermetallurgischen Erzeugnissen und die Oberflächenveredlung und Wärmebehandlung jeweils zum Schmelzen, Erwärmen, Warmhalten, Entspannen oder sonstigen Wärmebehandlung,\n" +
  "- chemische Reduktionsverfahren.";

export const CONSUMER_FORM_FIELD_DATA = {
  name: {
    name: "name",
    label: "Bezeichnung",
    type: "text",
    required: true,
    group: CONSUMER_TAB_VALUES.GENERAL,
    helpText: "Frei wählbar, wird nur zur Identifikation verwendet"
  },
  type: {
    name: "type",
    label: "Typ",
    type: "select",
    required: true,
    group: CONSUMER_TAB_VALUES.GENERAL,
    data: [
      {
        value: ConsumerComponentType.ProducingIndustry,
        label: "Industrie / Produzierendes Gewerbe"
      },
      {
        value: ConsumerComponentType.NonProducingIndustry,
        label: "Nicht produzierendes Gewerbe"
      },
      {
        value: ConsumerComponentType.PublicProperty,
        label: "Öffentliche Liegenschaft"
      },
      { value: ConsumerComponentType.Agriculture, label: "Landwirtschaft" },
      {
        value: ConsumerComponentType.PrivateHousehold,
        label: "Privathaushalt(e)"
      },
      {
        value: ConsumerComponentType.ElectricChargingStation,
        label: "Elektro-Ladesäule(n)"
      },
      { value: ConsumerComponentType.HeatPump, label: "Wärmepumpe" },
      {
        value: ConsumerComponentType.NightStorageHeating,
        label: "Nachtspeicherheizung"
      },
      { value: ConsumerComponentType.Other, label: "Sonstiger" }
    ]
  },
  person: {
    name: "person",
    label: "Unternehmen",
    type: "select",
    required: true,
    group: CONSUMER_TAB_VALUES.GENERAL,
    helpText:
      "Hier bitte das Unternehmen eintragen, welches den Verbraucher betreibt",
    data: []
  },
  connection: {
    name: "connection",
    label: "Netzverknüpfungspunkt",
    type: "select",
    required: true,
    group: CONSUMER_TAB_VALUES.GENERAL,
    data: []
  },
  yearly_energy: {
    name: "yearly_energy",
    label: "Jahresenergie [kWh]",
    type: "number",
    group: CONSUMER_TAB_VALUES.GENERAL,
    helpText:
      "Das ausgewählte Lastprofil wird in der Berechnung linear skaliert, so dass die Summe der Energie über ein Jahr der im Eingabefeld angegebenen Energie entspricht."
  },
  operational_purpose: {
    name: "operational_purpose",
    label: "Verbrauch für betriebliche Zwecke",
    type: "select",
    group: CONSUMER_TAB_VALUES.REGULATORY_DATA,
    data: [
      { value: OperationalPurpose.Yes, label: "Ja" },
      { value: OperationalPurpose.No, label: "Nein" }
    ]
  },
  eligible_for_tax_relief_for_particular_processes: {
    name: "eligible_for_tax_relief_for_particular_processes",
    label:
      "Erlass, Erstattung oder Vergütung der Steuer für bestimmte Prozesse und Verfahren",
    type: "select",
    group: CONSUMER_TAB_VALUES.REGULATORY_DATA,
    helpText: TAX_RELIEF_HELP_TEXT,
    data: [
      { value: TaxReliefProcesses.Electrolysis, label: "Elektrolyse" },
      {
        value: TaxReliefProcesses.GlasOrCeramic,
        label: "Herstellung von Glaswaren, keramischen Erzeugnissen, Baustoffen"
      },
      {
        value: TaxReliefProcesses.Metal,
        label: "Metallerzeugung und -bearbeitung"
      },
      {
        value: TaxReliefProcesses.ChemicalReduction,
        label: "Chem. Reduktionsverfahren"
      },
      { value: TaxReliefProcesses.None, label: "Nein" }
    ]
  },
  electricity_price: {
    name: "electricity_price",
    label: "Strompreis [ct/kWh]",
    type: "number",
    group: CONSUMER_TAB_VALUES.PRICE_DATA,
    helpText:
      "Basispreis inklusive Großhandel, Vertrieb und Marge aber ohne Netzentgelte, Stromsteuer usw."
  }
} as const satisfies {
  [key in keyof ConsumerFormData]?: FormInputData<ConsumerFormData, key>;
};
